import get from 'lodash.get';

const getColorPaletteConfigAssetUrl = (state) =>
  get(state, 'ws.template.meta.customization.colorPaletteConfigAssetUrl', null);

export default getColorPaletteConfigAssetUrl;
